import {
  Alert,
  AlertIcon,
  Button,
  HStack,
  Text,
  VStack,
} from '@chakra-ui/react';
import { KeyRound, UserPlus } from 'lucide-react';
import { useT } from '../../i18n';

// The join pages' first question when signed out (§1a): new people make an
// account, people already on Twinden sign in, so nobody gets a second one.
export function JoinChoice({
  onNew,
  onSignIn,
  signingIn,
  error,
}: {
  onNew: () => void;
  onSignIn: () => void;
  signingIn: boolean;
  error: string | null;
}) {
  const t = useT();
  return (
    <VStack spacing={3} align="stretch">
      {error && (
        <Alert status="error" borderRadius="xl">
          <AlertIcon />
          {error}
        </Alert>
      )}
      <Button
        h="56px"
        fontSize="17px"
        leftIcon={<UserPlus size={20} />}
        onClick={onNew}
        isDisabled={signingIn}
      >
        {t('account.join.imNew')}
      </Button>
      <Button
        h="56px"
        fontSize="17px"
        variant="outline"
        colorScheme="gray"
        leftIcon={<KeyRound size={20} />}
        onClick={onSignIn}
        isLoading={signingIn}
      >
        {t('account.join.alreadyUse')}
      </Button>
    </VStack>
  );
}

// Someone is already signed in on this device (§1a): carry on as them, or
// sign out and start again.
export function ContinueAs({
  name,
  onContinue,
  onSignOut,
}: {
  name: string;
  onContinue: () => void;
  onSignOut: () => void;
}) {
  const t = useT();
  return (
    <VStack spacing={4} align="stretch">
      <Button h="56px" fontSize="17px" onClick={onContinue} whiteSpace="normal">
        {t('account.join.continueAs', { name })}
      </Button>
      <HStack justify="center" spacing={1} flexWrap="wrap">
        <Text color="muted">{t('account.join.notYou')}</Text>
        <Button variant="link" onClick={onSignOut}>
          {t('account.join.signOut')}
        </Button>
      </HStack>
    </VStack>
  );
}
